














import Vue from "vue";

interface Data {
  /** モーダルの見出し文言 */
  headline: string;
  /** 補足文言 */
  description?: string;
  /**
   * OK ボタンに表示する文言
   * NOTE: デフォルトは OK
   */
  okLabel?: string;
  /**
   * キャンセルボタンに表示する文言
   * NOTE: デフォルトはキャンセル
   */
  cancelLabel?: string;
}

export default Vue.extend({
  name: "MessageModal",
  components: {},
  props: {
    headline: {
      type: String,
      required: true,
      default: "",
    },
    description: {
      type: String,
    },
    okLabel: {
      type: String,
      default: "OK",
    },
    cancelLabel: {
      type: String,
      default: "キャンセル",
    },
  },
  methods: {
    /** OK ボタン click ハンドラ */
    onClickOk() {
      this.$emit("onOk");
    },
    /** キャンセルボタン click ハンドラ */
    onClickCancel() {
      this.$emit("onCancel");
    },
  },
});
